// extracted by mini-css-extract-plugin
export default {"successData":"style_successData__mvcTv","title":"style_title__iX-8l","currVal":"style_currVal__JTGsi","Description":"style_Description__S3mBI"};